import React, { Fragment } from "react";
import ConfigHeight from "../HOC/ConfigHeigh";
const Card = (prop) => {
  var card = { ...prop.card };
  return (
    <Fragment>
      <div className="services_sec h-100 ">
        <div className="card rounded-3 h-100">
          <div className="card_img_wrapper rounded-3 text-center ">
            <i className={`fa ${card.icon_name} text-white fa-3x`}></i>
          </div>
          <div className="card-body ">
            <p className="card-text ">{card.text}</p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Card;
